import React from 'react';
import '../../module/order/orderCheckoutActions.css';
import './memberSectionPanel.css';

/**
 * Member / checkout-style section panel (replaces PrimeReact Fieldset).
 * Same visual language as OrderCheckOut “Your Order” (.co-checkout-panel).
 */
export default class MemberSectionPanel extends React.Component {

    static defaultProps = {
        collapsible: false,
        defaultOpen: true,
        className: '',
        bodyClassName: ''
    };

    constructor(props) {
        super(props);
        this.sectionId = props.sectionId
            || String(props.title || 'section')
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-|-$/g, '');
        this.state = {
            open: props.defaultOpen !== false
        };
    }

    toggle = () => {
        if (this.props.collapsible) {
            this.setState((prev) => ({open: !prev.open}));
        }
    };

    render() {
        const {title, children, collapsible, className, bodyClassName} = this.props;
        const isOpen = collapsible ? this.state.open : true;
        const headingId = `member-section-heading-${this.sectionId}`;
        const bodyId = `member-section-body-${this.sectionId}`;
        const panelClass = [
            'co-checkout-panel',
            'member-section-panel',
            collapsible ? 'co-checkout-panel--collapsible' : '',
            collapsible && !isOpen ? 'co-checkout-panel--collapsed' : '',
            className
        ].filter(Boolean).join(' ');
        const bodyClass = ['co-checkout-panel__body', bodyClassName].filter(Boolean).join(' ');

        return (
            <section className={panelClass} aria-labelledby={headingId}>
                {collapsible ? (
                    <h2 className="co-checkout-panel__head co-checkout-panel__head--toggle">
                        <button
                            type="button"
                            id={headingId}
                            className="co-checkout-panel__toggle"
                            aria-expanded={isOpen}
                            aria-controls={bodyId}
                            onClick={this.toggle}
                        >
                            <span className="co-checkout-panel__toggle-label">{title}</span>
                            <i className="material-icons co-checkout-panel__chevron" aria-hidden="true">expand_more</i>
                        </button>
                    </h2>
                ) : (
                    <h2 id={headingId} className="co-checkout-panel__head">
                        {title}
                    </h2>
                )}
                <div id={bodyId} className={bodyClass} hidden={collapsible && !isOpen}>
                    {children}
                </div>
            </section>
        );
    }
}
